<template>
  <div class="breadcrumb" v-if="$route.meta.breadcrumb">
    <div v-if="!$route.query.hide" class="fx fx-full menu-left">
      <!-- <div v-show="isShow" @click="goHome" class="goBack fl">
        <div class="goBackBtn"><i class="el-icon-back"></i></div>
        <div class="after">|</div>
      </div> -->
      <!-- <i v-show="!isShow" class="el-icon-menu fl"></i> -->
      <el-breadcrumb v-if="$route.meta.linkStep" separator="/">
      <!-- $route.meta.breadcrumb  -->
        <template v-for="(item, index) in breadcrumbMenuns">
          <el-breadcrumb-item v-if="index < 1" :key="index">{{$t(item)}}</el-breadcrumb-item>
          <el-breadcrumb-item v-else-if="(index + 1) == breadcrumbMenuns" :key="index">{{$t(item)}}</el-breadcrumb-item>
          <el-breadcrumb-item v-else :key="index"><a href="javascript:void(0);" @click="doClickBreadcrumb(index)">{{$t(item)}}</a></el-breadcrumb-item>
        </template>
      </el-breadcrumb>
      <el-breadcrumb v-else separator="/">
        <template v-for="(item, index) in $route.meta.breadcrumb">
          <el-breadcrumb-item :key="index">{{$t(item)}}</el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </div>
    <div class="breadcrumb-btn">
      <!-- <el-popover placement="bottom" popper-class="menu-popper">
        <ul class="menu">
          <li class="menu-item">购买条数:<em /><span>{{rightCounts.type1.surplus}}</span><em />/<em />{{rightCounts.type1.total}}</li>
          <li class="menu-item" v-if="!giveTotal">赠送条数:<em /><span>{{giveSurplus}}</span><em />/<em />{{giveTotal}}</li>
          <li class="sub-menu" v-else>
            <div class="sub-menu-title" @click="submenuShow = !submenuShow">
              赠送条数:<em /><span>{{giveSurplus}}</span><em />/<em />{{giveTotal}}
              <i :class="`el-icon-arrow-${['down', 'up'][+submenuShow]}`"></i>
            </div>
            <el-collapse-transition>
              <ul class="menu" v-if="submenuShow">
                <li class="menu-item" v-if="rightCounts.type2.total" style="padding-left: 25px">幸运转盘:<em /><span>{{rightCounts.type2.surplus}}</span><em />/<em />{{rightCounts.type2.total}}</li>
                <li class="menu-item" v-if="rightCounts.type3.total" style="padding-left: 25px">商机礼包:<em /><span>{{rightCounts.type3.surplus}}</span><em />/<em />{{rightCounts.type3.total}}</li>
              </ul>
            </el-collapse-transition>
          </li>
        </ul>
        <span class="popover-reference" slot="reference">
          剩余条数：<span style="color: #4181FF;" :key="mustkey">{{ surplus }}</span> / <span>{{ total }}</span><i class="el-icon-arrow-down el-icon--right"></i>
        </span>
      </el-popover>
      <el-tooltip effect="dark" content="剩余条数 / 权益数" placement="bottom-end">
        <i class="el-icon-question"></i>
      </el-tooltip> -->

      <!-- <a @click="$router.push('/clue/myAttention')" v-if="getRoute()" class="ml-20">
        <img src="@/assets/industry/xing.png" alt /> 我的关注
      </a> -->
      <!-- <a @click="openDialog" v-if="getRoute()">
        <img src="@/assets/industry/jian.png" alt /> 智能推荐
      </a> -->
    </div>
    <newRecommendDialog v-if="showRecommendDialog" ref="recommendDialog" v-model="showRecommendDialog"></newRecommendDialog>
  </div>
</template>

<script>
import { cueQuotaStatistics } from '@/views/home/api'
import recommendDialog from '@/components/recommendDialog'
import newRecommendDialog from '@/components/newRecommendDialog'
import { getTotalTimes, getUsedTimes, newGetTotalTimes } from '@/api/totals.js'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import {subscribeManagement} from '@/views/clue/api/subscribeApi'

export default {
  name: 'crumbs',
  components: {
    newRecommendDialog
  },
  data () {
    return {
      breadcrumbMenuns: [], // 面包血
      showRecommendDialog: false,
      isShow: false,
      history,
      mustkey: 0,
      rightCounts: {
        type1: { surplus: 0, total: 0 }, // 购买条数
        type2: { surplus: 0, total: 0 }, // 幸运转盘
        type3: { surplus: 0, total: 0 } // 商机礼包
      },
      submenuShow: false,
      surplus: 0,
      total: 0,
      giveSurplus: 0,
      giveTotal: 0,
      confirmed: false
    }
  },
  created(){

  },
  mounted () {
    this.getSubscribeManagement()
    this.getTotalTimes()
    this.setBmm()
    
    window._setCrumbs = (val)=> {
      this.breadcrumbMenuns = val
    }
    this.$store.commit('CLICK_COMPANY_ARR',JSON.parse(localStorage.getItem('clickList'))||[])
  },
  computed: {
    ...mapState({
      frequency: state => state.user.frequency
    })

  },
  watch: {
    frequency: function () {
      this.getTotalTimes()
    },
    $route: {
      immediate: true,
      handler (val) {

        this.setBmm()
    
        if (val.path === '/zxk/home') {
          this.isShow = false
        } else {
          this.isShow = true
        }
      }
    },
  },
  methods: {
    setBmm() {
      let mbx = this.$route.meta.breadcrumb
      if(mbx && typeof mbx === 'object' && mbx.length){
        this.breadcrumbMenuns = this.$route.meta.breadcrumb
      }
    },
    doClickBreadcrumb (step) {
      this.$bus.$emit('breadcrumb-step', step)
    },
    goHome () {
      const { linkStep, breadcrumb = [] } = this.$route.meta || {}
      if (linkStep && breadcrumb.length > 2) {
        this.$bus.$emit('breadcrumb-step', breadcrumb.length - 2)
        return
      }
      if (history.length === 1) {
        this.$router.push({ path: '/zxk/home' })
      } else {
        this.$router.go(-1)
      }
    },
    confirm () {
      if (!this.confirmed) {
        this.confirmed = true
        this.$store.dispatch('PERMISSION_CONFIRM')
      }
      // if (sessionStorage.getItem('initMbox') === '0') {
      //   sessionStorage.setItem('initMbox', 1)
      //   this.$confirm('您当前账号无权限，请先购买后再登录操作', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     closeOnPressEscape: true,
      //     type: 'warning'
      //   }).then(() => {
      //     window.location.href = process.env.VUE_APP_OW_DOMAIN + 'item/235.html'
      //     sessionStorage.setItem('initMbox', 0)
      //   }).catch(() => { })
      // }
    },
    // getUsedTimes() {
    //   getUsedTimes({}).then(res => {
    //     this.expend = res.data || 0
    //     // this.mustkey++
    //     // alert(this.expend)
    //     // console.log('??',this.expend)
    //     if ((this.total - res.data) <= 0) {
    //       this.confirm()
    //     }
    //   }).catch((err) => {
    //     // this.confirm()
    //     console.log(err)
    //   })
    // },
    
    getSubscribeManagement () {
      subscribeManagement().then(res =>{
          if (res.code == 200) {
            if(res.data.length<1){
              this.$store.commit('SET_LANDING_PAGE',true)
            }
          }
      })
    },
    getTotalTimes () {
      cueQuotaStatistics().then(res => {
        if(res.code == 200){
            const surplus = res.data.companyInterest.total - res.data.companyInterest.usedTotal
            this.$store.commit('SET_CLOSEDATE', res.data.closeDate || '--')
            this.$store.commit('SET_SURPLUS', surplus)
            this.$store.commit('SET_USEDTOTAL', res.data.companyInterest.usedTotal)
            this.$store.commit('SET_TOTAL', res.data.companyInterest.total)
            this.$store.commit('SET_STATISTICS', res.data)
            if (res.data.companyInterestExpireFlag) {
              this.$message.warning('权益已到期，避免影响使用，请联系客服进行续费')
            }
            console.log('cueQuotaStatistics',surplus)
        }
      })
      // newGetTotalTimes({}).then(res => {
      //   if (res.code == 200) {
      //     (res.data || []).forEach(({ surplus, total, type }) => {
      //       this.rightCounts[`type${type}`] = { surplus: surplus < 1 ? 0 : surplus, total }
      //     })
      //     this.surplus = ['type1', 'type2', 'type3'].reduce((p, n) => p + this.rightCounts[n].surplus, 0)
      //     this.total = ['type1', 'type2', 'type3'].reduce((p, n) => p + this.rightCounts[n].total, 0)
      //     this.giveSurplus = ['type2', 'type3'].reduce((p, n) => p + this.rightCounts[n].surplus, 0)
      //     this.giveTotal = ['type2', 'type3'].reduce((p, n) => p + this.rightCounts[n].total, 0)
      //     this.$store.commit('SET_TOTAL', this.total)
      //     if (this.surplus <= 0) {
      //       this.confirm()
      //     }
      //   }
      // }).catch((err) => console.log(err))

      // getTotalTimes({}).then(res => {
      //   this.total = res.data
      //   this.getUsedTimes()
      // }).catch((err) => {
      //   // this.confirm()
      //   console.log(err)
      // })
    },
    getRoute () {
      if (this.$route.name === '推荐列表' || this.$route.name === '商机列表' || this.$route.name === '商机线索') {
        return true
      } else {
        return false
      }
    },
    openDialog () {
      this.showRecommendDialog = true
    }
  }
}
</script>

<style scoped lang="scss">
.breadcrumb {
  height: 38px;
  width: 100%;
  position: relative;
  // background: #fafafa;
  z-index: 1000;
  display: flex;
  margin-top: 1px;
  padding-top: 0;
  padding-left: 15px;
  .menu-left {
    align-items: center;
  }
  .goBack {
    position: relative;
    .goBackBtn {
      font-weight: 400;
      color: #fff;
      background-color: #4f7afd;
      cursor: pointer;
      font-size: 14px;
      font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
        Microsoft YaHei, Arial, sans-serif;
      border-radius: 2px;
      /* line-height: 23px; */
      width: 16px;
      height: 16px;
      text-align: center;
      margin-top: 3px;
      margin-right: 25px;
    }
    .after {
      color: #c0c4cc;
      position: absolute;
      top: 2px;
      left: 30px;
    }
  }
  .el-icon-menu {
    margin-right: 10px;
    color: #999;
    font-size: 20px;
  }
  .el-breadcrumb {
    line-height: 14px;
  }
  .breadcrumb-btn {
    position: absolute;
    right: 30px;
    top: 0px;
    line-height: 38px;
    img {
      width: 14px;
      height: 14px;
      position: relative;
      top: -1px;
    }
    a {
      margin-left: 20px;
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
}
.breadcrumb-btn {
  .el-icon-question {
    cursor: pointer;
    font-size: 18px;
    margin-left: 12px;
    color: #409eff;
  }
}
.menu {
  .menu-item,
  .sub-menu-title {
    line-height: 30px;
    margin: 0;
    font-size: 14px;
    padding: 0 10px;
    color: #606266;
    outline: none;
    display: flex;
    align-items: center;
    &:hover {
      background-color: #ecf5ff;
    }
    i[class^="el-icon-arrow-"] {
      margin-left: auto;
      &:hover {
        color: #66b1ff;
      }
    }
    span {
      color: #4181ff;
    }
    em {
      margin: 2px;
    }
  }
  .sub-menu-title {
    cursor: pointer;
  }
}
.popover-reference {
  cursor: pointer;
}
.breadcrumb{
    line-height: 0;
    padding: 16px 24px;
    padding-bottom: 0;
}
/deep/ {
  .el-breadcrumb__item{
    font-size: 16px;
    span{
      font-size: 16px;
    }
  }
  .el-breadcrumb__separator{
    margin: 0 1px;
    color: rgba(153, 153, 153, 1);
  }
  .el-breadcrumb__inner{
    font-weight: 600;
    color: rgba(153, 153, 153, 1);
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover{
    color: rgba(52, 57, 81, 1);
    font-weight: 600;
  }
}
</style>
<style lang="scss">
.menu-popper {
  padding: 10px 0;
  .sub-menu-title {
    i {
      padding-left: 24px;
    }
  }
}
</style>
